



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PaymentOrderState from '@/models/Accounts/Shared/PaymentOrders/PaymentOrderState';

@Component({ name: 'PaymentOrderState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    status: PaymentOrderState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.status) {
            case PaymentOrderState.PendingApproval:
                color = "warning--text";
                break;
            case PaymentOrderState.Submitted:
                color = "success--text";
                break;
            case PaymentOrderState.Cancelled:
            case PaymentOrderState.Rejected:
            case PaymentOrderState.Expired:
                color = "error--text";
                break;
            default:
                color = "grey-text";
                break;
        }
        return color;
    }

}
